module.exports = __webpack_public_path__ + "img/1512226063.07807645.jpg";